export default "__VITE_ASSET__CR21Vg5m__"